// extracted by mini-css-extract-plugin
export default {"main":"NewContent_main__OUPg+","div1":"NewContent_div1__kizcM","div2":"NewContent_div2__u6IjK"};